/**
 * Created by nguyenlet on 12/29/2015.
 *
 */

import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UserUrl } from '../shared/urls/user.url';
import { AppConstants } from '../shared/constants/constants';
import { AppMessages } from '../shared/constants/messages';
import { ValidationService } from '../shared/services/validation.service';
import * as moment from 'moment';

@Injectable()
export class Utility {
  ///TODO: implement static common class here
  public static months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  public static assetFolder = '/assets';

  public ASSET_FOLDER = '/assets';

  public static get GET_RANDOM_IMAGE_URL() {
    return Math.random().toString(36).substring(7);
  }


  /**
   * @param format - 'print the {0} to {1}'
   * @param args - ['name', 'table']
   * @returns {XML|string|void|*} - print the name to table
   */
  public static stringFormat(format, args) {
    const regex = new RegExp('{-?[0-9]+}', 'g');
    if (typeof format !== 'string') {
      return '';
    }

    return format.replace(regex, function (item) {
      /* tslint:disable */
      const intVal = parseInt(item.substring(1, item.length - 1));
      let replace = '';
      if (intVal >= 0) {
        replace = args[intVal];
      } else if (intVal === -1) {
        replace = '{';
      } else if (intVal === -2) {
        replace = '}';
      } else {
        replace = '';
      }
      return replace;
    });
  }

  /**
   * Convert date object to date string
   * @param string date formated
   */
  public static formatDate(date) {
    if (Object.prototype.toString.call(date) !== '[object Date]' || isNaN(date.getTime())) {
      date = new Date();
    }
    return Utility.stringFormat(AppConstants.dateConfig.dateFormat, [date.getDate(), this.months[date.getMonth()], date.getFullYear()]);
  }

  // Form validation
  /**
   * @param name - 'User Name'
   * @returns {string} - The User Name is required
   */
  public getRequireError(name) {
    //  return this.stringFormat(AppConstants.errorMessage.require, [name]);
  }

  public getDefaultSelectOption(name) {
    return Utility.stringFormat(AppConstants.formConfig.selectBox.default, [name]);
  }

  public getDefaultFilterOption(name) {
    return Utility.stringFormat(AppConstants.formConfig.selectBox.filter, [name]);
  }

  public getDefaultFilterInput(name) {
    return Utility.stringFormat(AppConstants.formConfig.textBox.filter, [name]);
  }

  public getPopupConfirmMessage(name) {
    return Utility.stringFormat(AppMessages.dialog.confirmMessage, [name]);
  }

  public getDefaultDateOfBirth() {
    const date = new Date('1999-01-01T12:00:00Z');
    return date;
  }

  public inputMaxLength() {
    return AppConstants.formConfig.textBox.maxLength;
  }
  public inputMinLength() {
    return AppConstants.formConfig.textBox.minLength;
  }

  public inputMaxLengthNumberPhone() {
    return AppConstants.formConfig.textBox.maxLengthNumberPhone;
  }

  public textAreaMaxLength() {
    return AppConstants.formConfig.textArea.maxLength;
  }

  public inputDatePlaceholder() {
    return AppConstants.formConfig.textBox.datePlaceholder;
  }

  public get pageSize() {
    return AppConstants.pagingConfig.pageSize;
  }

  public isMapImageRule(file) {
    const filesize = ((file.size / 1024) / 1024).toFixed(4); // MB
    const ext = file.name.split('.').pop().toLowerCase();
    if (AppConstants.uploadFileConfig.image.indexOf(ext) >= 0 && Number(filesize) <= Number(AppConstants.uploadFileConfig.imageSize)) {
      return true;
    }
    return false;
  }

  /**
   *
   * @param file: file upload
   * @param fileExt : pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt
   * @param fileSize : MB
   */
  public isValidFile(file, fileExt, fileSize) {
    const filesize = ((file.size / 1024) / 1024).toFixed(4); // MB
    const ext = file.name.split('.').pop().toLowerCase();
    if (fileExt.indexOf(ext) >= 0 && Number(filesize) <= Number(fileSize)) {
      return true;
    }
    return false;
   }

  /**
   * Convert date to UTC timestamp in seconds. If date is invalid, return current Date
   * @param Date object date
   */
  public convertDateToTimeStamp(date) {
    if (Object.prototype.toString.call(date) !== '[object Date]' || isNaN(date.getTime())) {
      date = new Date();
    }
    return Math.floor(date / 1000);
  }

  public convertTimeSpampToDate(timestamp) {
    const date = new Date(timestamp);
    return date;
  }

  public convertDateToString(date) {
    if (Object.prototype.toString.call(date) !== '[object Date]' || isNaN(date.getTime())) {
      return null;
    }
    return Utility.stringFormat(AppConstants.dateConfig.dateStringFormat, [date.getFullYear(), date.getMonth()+1, date.getDate()]);
  }
  public convertDateToLocalString(date, format='YYYY-MM-DDTHH:mm:ss') {
    return moment.utc(date).local().format(format);
  }
  public convertDateToISOString(date) {
    if (Object.prototype.toString.call(date) !== '[object Date]' || isNaN(date.getTime())) {
      return null;
    }
    return date.toISOString();
  }

}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/common/utility.ts